import { Check } from 'lucide-react';

/**
 * LpFeatures — Concise feature/benefit list for PPC landing pages.
 * Each LP gets 3-4 bullets pulled from lpConfig.js.
 */
export const LpFeatures = ({ config }) => {
  return (
    <section className="bg-white py-12 lg:py-16" data-testid="lp-features">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-semibold text-[#0B2240] mb-8">
          What you get with KGOB
        </h2>
        <ul className="grid gap-4 sm:grid-cols-2">
          {(config.features || []).map((feature, i) => (
            <li
              key={i}
              className="flex items-start gap-3 rounded-xl border border-[#E8E5DC] bg-[#F7F6F2] p-4"
              data-testid={`lp-feature-${i}`}
            >
              <span className="mt-0.5 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#C9A961]/15 text-[#0B2240]">
                <Check className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="text-[#0B2240] text-sm sm:text-base leading-relaxed">
                {feature}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
